import { useState } from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { GamesGrid } from "./components/GamesGrid";
import { Footer } from "./components/Footer";
import "./App.css";

function App() {
    const [resetSignal, setResetSignal] = useState(0);

    return (
        <div className="App min-h-screen">
            <Header onReset={() => setResetSignal((n) => n + 1)} />
            <main>
                <Hero />
                <GamesGrid resetSignal={resetSignal} />
            </main>
            <Footer />
        </div>
    );
}

export default App;
